<template>
  <div id="login">
    <el-container class="page_login">
      <el-main>
        <div class="xueming">
          晓评学生评价 | <span style="font-size: 26px">让花成花,让树成树</span>
        </div>
        <!-- 登录卡片区域 -->
        <el-card class="box_card" style="padding: 0px">
          <div class="card_content">
            <div class="download-area">
              <div style="height: 32px; width: 1px"></div>
              <div class="download-area__item-wrap">
                <div
                  class="download-area__item"
                  @mouseover="moveIn"
                  @mouseout="moveOut"
                >
                  <img
                    class="download-area__item-qrcode"
                    src="../../assets/img/app-link.jpg"
                  />
                  <a class="download-area__item-intro" href="javascript:;">
                    <div class="download-area__item-intro__logo micro"></div>
                    <span class="download-area__item-intro__txt">小程序</span>
                  </a>
                </div>
                <div class="download-area__item-split-line"></div>
              </div>
              <div class="download-area__item-wrap" style="margin-top: 20px">
                <div class="download-area__item">
                  <a
                    class="download-area__item-intro"
                    href="https://cdn.51xiaoping.com/download/pcxp/%E6%99%93%E8%AF%84%E7%BB%BC%E5%90%88%E8%AF%84%E4%BB%B7Setup.exe"
                  >
                    <div class="download-area__item-intro__logo Windows"></div>
                    <span class="download-area__item-intro__txt"
                      >Windows下载</span
                    >
                  </a>
                </div>
              </div>
            </div>
            <div class="solid"></div>
            <!-- <div class="content_left"></div> -->
            <div class="content_right">
              <!-- 右侧上部 -->
              <div class="content_right_top">统一身份认证登录</div>
              <div class="djhasiufag">
                <span @click="ruleForm.region = 'teacher'"
                  >我是教师
                  <div v-if="ruleForm.region == 'teacher'"></div> </span
                ><span @click="ruleForm.region = 'parent'"
                  >我是家长
                  <div v-if="ruleForm.region == 'parent'"></div
                ></span>
              </div>
              <!-- 右侧下部表单区域 -->
              <el-form
                class="form_login"
                ref="login"
                :model="ruleForm"
                :rules="formRiles"
              >
                <!-- <el-form-item class="form_select" prop="region">
                  <i class="iconp"
                    ><img
                      src="../../assets/img/login/shengfeng.png"
                      alt=""
                      srcset=""
                    />
                  </i>
                  <el-select
                    class="form_select_select"
                    v-model="ruleForm.region"
                    placeholder="请选择你的身份"
                    prefix-icon="el-icon-user"
                  >
                    <el-option label="学校管理员" value="school"></el-option>
                    <el-option label="教师" value="teacher"></el-option>
                    <el-option label="家长" value="parent"></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item prop="name">
                  <i class="iconp"
                    ><img
                      src="../../assets/img/login/shengfeng.png"
                      alt=""
                      srcset=""
                    />
                  </i>
                  <el-input
                    name="account"
                    v-model.trim="ruleForm.name"
                    placeholder="请输入用户名"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password" class="password-input">
                  <i class="iconp"
                    ><img
                      src="../../assets/img/login/mima.png"
                      alt=""
                      srcset=""
                    />
                  </i>
                  <el-input
                    v-model.trim="ruleForm.password"
                    type="password"
                    placeholder="请输入密码"
                    show-password
                    @keyup.enter.native="submitForm()"
                  ></el-input>
                </el-form-item>
                <div class="wanji" @click="goForget">忘记密码?</div>
                <el-button type="primary" @click="submitForm">登录</el-button>
              </el-form>
              <div
                style="color: #0082ef; font-size: 20px"
                v-if="ruleForm.region == 'teacher'"
                class="sfasfafgas"
                @click="dengs"
              >
                <img
                  class="imgshfaf"
                  src="../../assets/img/qwdl.png"
                  width="29px"
                />
                企业微信登录
              </div>
            </div>
          </div>
        </el-card>
      </el-main>
      <el-footer style="z-index: 88">
        <div class="szjy">
          <div class="szjy_left"></div>
          <div class="szjy_content">开启素质教育美好新生态</div>
          <div class="szjy_right"></div>
        </div>
        <foo-ter></foo-ter>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import fooTer from '../footer/footer'
import { userlogin, zpUrl } from '@/api/home'
export default {
  components: {
    fooTer,
  },
  data() {
    return {
      // 表单输入值
      ruleForm: {
        region: 'teacher',
        name: '',
        password: '',
      },
      //   token
      token: '',
      zpUrl: zpUrl,
      //   表单验证
      formRiles: {
        region: [{ required: true, message: '请选择角色', trigger: 'change' }],
        name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.submitForm()
  },
  methods: {
    moveIn(e) {
      // console.log(e.currentTarget)
      // e.currentTarget.className =
      //   'download-area__item download-area__item--display'
    },
    moveOut(e) {
      e.currentTarget.className = 'download-area__item'
    },
    dengs() {
      let url = 'http://' + window.location.hostname + '/#/qywx/index'
      url = encodeURIComponent(url)
      window.location.href =
        'https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=wwea25dbad39f04c7d&redirect_uri=' +
        url +
        '&usertype=member'
    },
    submitForm() {
      this.$refs.login.validate((valid) => {
        if (valid) {
          this.formHandler()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async formHandler() {
      try {
        const { data: res } = await userlogin({
          roleType: this.ruleForm.region, //school
          // roleType: 'school',
          account: this.ruleForm.name,
          password: this.ruleForm.password,
        })
        // 登录为学生的时跳转
        // if (this.ruleForm.roleType == 'student') {
        //   window.location.href = 'http://live.welaiedu.cn/#/?token=' + res.token
        // }
        // 第一次登录时
        if (res.data.isSettingPwdQuestion == 0) {
          // 添加token到localStorage
          window.localStorage.setItem('token', res.data.token)
          // 添加登录ID到localStorage
          localStorage.setItem('userId', res.data.userId)
          localStorage.setItem('schoolIds', res.data.userId)
          // 添加roleType到localStorage
          localStorage.setItem('roleType', res.data.roleType)
          localStorage.setItem('roleTypes', res.data.roleType)
          this.$message.info(
            '检测到您尚未设置密保问题,需要先设置密保问题。设置完密保问题系统会帮您自动登录'
          )
          this.$router.push('/user/checkFirstlogin')
        } else {
          if (this.ruleForm.region == 'parent') {
            window.open(
              zpUrl +
                '?token=' +
                res.data.token +
                '&roleId=' +
                res.data.roleList[0].id
            )
            return false
          }
          // 添加token到localStorage
          window.localStorage.setItem('token', res.data.token)
          // 添加登录ID到localStorage
          localStorage.setItem('userId', res.data.userId)
          localStorage.setItem('schoolIds', res.data.userId)
          // 添加roleType到localStorage
          localStorage.setItem('roleType', res.data.roleType)
          localStorage.setItem('roleTypes', res.data.roleType)
          // 提示登录成功
          this.$message({
            message: '登录成功',
            type: 'success',
          })
          // 跳转到工作台
          this.$router.push('/bench')
        }
      } catch (err) {
        console.log(err)
      }
    },
    goForget() {
      this.$router.push('/forget')
    },
  },
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
.page_login {
  background-color: #f0f2f5;
  width: 100%;
  position: relative;
}

/* 卡片区域样式 */

.box_card {
  width: 660px;
  height: 430px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* bottom: calc(12vw + 70px);
  left: 0;
  right: 0; */
  /* margin: auto; */
  background-color: #fff;
  border-radius: 20px;
  z-index: 99;
}

.card_content {
  width: 660px;
  height: 430px;
  /* padding-top: 35px; */
  border-radius: 10px;
  /* background-color:red; */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card_content .content_left {
  width: 525px;
  height: 490px;
  background: #fff url('../../assets/img/login/left_image.e43f246f.png')
    no-repeat 100% 100%;
}

.card_content .content_right {
  margin: 30px 10px;
  width: 400px;
  /* height: 400px; */
  /* border: 1px solid #dcdfe6; */
}

.content_right_top {
  /* height: 80px; */
  font-size: 30px;
  color: #4887ff;
  letter-spacing: 6px;
  /* padding-left: 20px; */
  text-align: center;
  margin-bottom: 15px;
  /* background: #fff url('../../assets/img/login/right-top-text.png'); */
}

.content_right .form_login {
  margin: 20px;
}

.el-scrollbar__view {
  padding: 10px;
}

.form_select {
  width: 100%;
}

.form_select_select {
  width: 360px;
}

.el-select-dropdown__item {
  padding-left: 10px;
  width: 360px;
}

.form_login .el-form-item {
  /* margin-top: 40px; */
}

.el-button {
  width: 100%;
  height: 40px;
  border-radius: 20px;
  margin-top: 20px;
}

.wanji {
  width: 60px;
  font-size: 12px;
  margin-top: 18px;
  color: #ababab;
  cursor: pointer;
}
.iconp {
  position: absolute;
  top: 5px;
  left: 10px;
  z-index: 10;
}
.xueming {
  margin: 50px 0 0 60px;
  font-size: 30px;
  color: #ffffff;
  letter-spacing: 3.08px;
}
.szjy {
  width: 350px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  letter-spacing: 1.23px;
}
.szjy_left {
  height: 0px;
  width: 60px;
  border: 1px solid #fff;
}
.szjy_content {
  font-size: 16px;
}
.szjy_right {
  height: 0px;
  width: 60px;
  border: 1px solid #fff;
}
.imgshfaf {
  vertical-align: middle;
}
.sfasfafgas {
  cursor: pointer;
  text-align: center;
}
.download-area {
  /* position: absolute;
  bottom: 70px;
  left: 0;
  right: 0; */
  margin: 0px 20px;
  height: 100%;
  padding: 30px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  justify-content: space-between;
  flex-direction: column;
  z-index: 100;
}
.download-area,
.download-area__item {
  /* height: 11.22vw; */
  display: flex;
  align-items: center;
}
.download-area__item-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.download-area__item {
  position: relative;
  /* width: 9.52vw; */
  width: 185px;
  /* display: flex;
  align-items: center; */
  flex-direction: column;
  justify-content: flex-end;
  /* margin: 0 1.105vw; */
  /* border: 0.085vw solid transparent; */
}
.download-area__item--display {
  background: hsla(0, 0%, 100%, 0.88);
  border: 0.085vw solid hsla(0, 0%, 100%, 0.8);
  box-shadow: 0 0.85vw 2.04vw rgb(0 0 0 / 6%);
  -webkit-backdrop-filter: blur(0.85vw);
  backdrop-filter: blur(0.85vw);
  border-radius: 0.51vw;
  z-index: 11;
}
.download-area__item-split-line {
  content: '';
  position: relative;
  margin-bottom: 0.85vw;
  width: 0.085vw;
  height: 1.53vw;
  background: #fff;
  mix-blend-mode: normal;
  opacity: 0.1;
  border-radius: 0.34vw;
}
.download-area__item-intro {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-bottom: 0.85vw; */
}
.download-area__item-intro__txt {
  position: relative;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  /* font-size: 1.19vw;
  line-height: 1.7vw; */
  /* color: #fff; */
  color: #09f;
}
a {
  text-decoration: none;
}
.download-area__item-qrcode {
  position: relative;
  width: 130px;
  height: 130px;
  margin-bottom: 15px;
  /* width: 6.79065vw;
  height: 6.63935vw;
  margin-top: 1.17895vw;
  margin-bottom: 0.82535vw; */
  /* display: none; */
}
.download-area__item:hover .download-area__item-qrcode {
  display: block;
}
.download-area__item:hover .download-area__item-intro__txt {
  color: #09f;
}

element.style {
}
.download-area__item-intro__logo {
  overflow: hidden;
  position: relative;
  height: 32px;
  width: 32px;
  margin-right: 10px;
  /* width: 1.7vw;
  height: 1.7vw; */
  /* margin-right: 0.51vw; */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
}
.download-area__item:hover .download-area__item-intro__logo.Windows {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEVSURBVHgB7dsxSsRQGEbRP6MLGfcmDK5oENybuhEjIxZ2ksb7wHOqlI/ckKT5ZgAAAAD4L7Y56nnfZwV3c57H7f3r+rqf5zSvs4LLduienoaUADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYADEBYgLEBIgJEBMgJkBMgNj9HPUxD7OCy/c65uZpe5vrvsa5gAOOj/Rug7gV3F47P616rl8c/wasskZ82ddcSR58qP0FxQSICRATICZATICYADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYADEBYgIAAAAAwB/5BCPxGXK43YEEAAAAAElFTkSuQmCC);
}
/* .download-area__item .download-area__item-intro__logo.Windows {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEFSURBVHgB7dtBSsRAEEDRiniQeP9DqSeJGVBwpcSFv4d5b5MOZFHkQ+9qBgAAAIBHsc1Fx2nWsG/b9n47nCPt5+N1FnDOdOmfPg0pAWICxASICRATICZATICYADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYALHnue5lFvC1HfN5fjuOY4m5gCv+sqS3zwJu187391Xn+vX7uciW5M9sSd4ZAWICxASICRATICZATICYADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYAAAAAADwTz4AVaofklm/waMAAAAASUVORK5CYII=);
} */
.download-area__item .download-area__item-intro__logo.Windows {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEVSURBVHgB7dsxSsRQGEbRP6MLGfcmDK5oENybuhEjIxZ2ksb7wHOqlI/ckKT5ZgAAAAD4L7Y56nnfZwV3c57H7f3r+rqf5zSvs4LLduienoaUADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYADEBYgLEBIgJEBMgJkBMgNj9HPUxD7OCy/c65uZpe5vrvsa5gAOOj/Rug7gV3F47P616rl8c/wasskZ82ddcSR58qP0FxQSICRATICZATICYADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYADEBYgIAAAAAwB/5BCPxGXK43YEEAAAAAElFTkSuQmCC);
}

.download-area__item:hover .download-area__item-intro__logo.micro {
  background-image: url(data:image/png;base64,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);
}
/* .download-area__item .download-area__item-intro__logo.micro {
  background-image: url(data:image/png;base64,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);
} */
.download-area__item .download-area__item-intro__logo.micro {
  background-image: url(data:image/png;base64,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);
}
.password-input {
  margin-top: 20px;
}
.flex_box {
  display: flex;
  algin-item: flex-end;
}
@media all and (max-height: 800px) {
  .xueming {
    margin-top: 20px;
  }
}
.solid {
  width: 1px;
  height: 360px;
  border-right: 1px solid #c9c9c9;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue